// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "shimport" + "." + "8b58c2cc8bbabec7978c" + ".js";
};